export function detectBiometricType(): 'face' | 'fingerprint' | 'unknown' {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad/.test(userAgent)) {
    return 'face'; // iPhones generally use Face ID or Touch ID
  }

  if (/android/.test(userAgent)) {
    return 'fingerprint'; // Most Androids use fingerprint
  }

  return 'unknown'; // Fallback
}

export function detectMobilePlatform(): { isIos: boolean; isAndroid: boolean; isMobile: boolean } {
  const ua = navigator.userAgent.toLowerCase();
  // X1: Use maxTouchPoints for iPad detection (more reliable than ontouchend which false-positives on Mac Touch Bar)
  const isIos = /iphone|ipad|ipod/.test(ua) || (/macintosh/.test(ua) && navigator.maxTouchPoints > 2);
  const isAndroid = /android/.test(ua);
  const isMobile = isIos || isAndroid;
  return { isIos, isAndroid, isMobile };
}

export function getBiometricName(isIos: boolean, isAndroid: boolean): string {
  if (isIos) return 'Face ID or Touch ID';
  if (isAndroid) return 'Fingerprint or Face Unlock';
  return 'Biometric authentication';
}

export function getPlatformName(isIos: boolean, isAndroid: boolean): string {
  if (isIos) return 'iOS';
  if (isAndroid) return 'Android';
  return 'your device';
}
